import { useAuth } from "@/context/AuthContext";
import OwnerDashboard from "./dashboards/OwnerDashboard";
import AdvisorDashboard from "./dashboards/AdvisorDashboard";
import MechanicDashboard from "./dashboards/MechanicDashboard";
import StorekeeperDashboard from "./dashboards/StorekeeperDashboard";
import CashierDashboard from "./dashboards/CashierDashboard";
import DriverDashboard from "./dashboards/DriverDashboard";
import { StatusBadgeSmall } from "./dashboards/legacyStatusBadge.js";

/**
 * Dashboard — router that selects a role-specific dashboard variant.
 *
 * All variants share the Fender design system (Deep Space Blue sidebar,
 * Strawberry Red accents, Frosted Blue informational tiles) and the same
 * building blocks (KpiCard, NeedsAttention, WorkshopLoadDonut, JobsTrendChart,
 * ActiveJobsTable).  Only the CONTENT changes per role.
 */
export default function Dashboard() {
  const { user } = useAuth();
  const role = user?.role || "owner";

  if (role === "mechanic") return <MechanicDashboard user={user} />;
  if (role === "storekeeper") return <StorekeeperDashboard user={user} />;
  if (role === "driver") return <DriverDashboard user={user} />;
  if (role === "advisor") return <AdvisorDashboard user={user} />;
  if (role === "cashier") return <CashierDashboard user={user} isCashier />;
  if (role === "accountant") return <CashierDashboard user={user} isCashier={false} />;

  // owner + branch_manager get the full spec-compliant dashboard.
  return <OwnerDashboard user={user} />;
}

// re-export the StatusBadgeSmall for other files that still import it from here
export const StatusBadge = StatusBadgeSmall;
